class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.695 10.258c0-2.308-1.89-2.571-3.409-2.782-1.655-.23-2.591-.43-2.591-1.855C5.695 4.425 6.949 4 8.022 4a3.377 3.377 0 0 1 2.784 1.314l.778-.628a4.325 4.325 0 0 0-2.889-1.638V1.5h-1v1.511c-1.808.11-3 1.13-3 2.61 0 2.365 1.915 2.631 3.454 2.845 1.626.226 2.546.421 2.546 1.792 0 1.516-1.566 1.742-2.5 1.742-1.715 0-2.44-.482-3.11-1.314l-.779.628a4.218 4.218 0 0 0 3.389 1.668V14.5h1v-1.523c1.863-.152 3-1.163 3-2.72Z"></path></svg>';
  }
}
const e = "pi-currency-dollar";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
